import React from "react";

import { useAuth } from "src/contexts/AuthContext";

// Persistent banner shown while an admin is impersonating an app user via the
// /admin support-login flow. Renders nothing otherwise. "Stop" submits a DELETE
// to the Rails session route, which signs the user out and returns to /admin.
export default function ImpersonationBanner() {
  const { impersonation } = useAuth();

  if (!impersonation?.active) return null;

  const { impersonated_user: target, write_allowed: writeAllowed, stop_path: stopPath } = impersonation;
  const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";

  return (
    <div
      role="alert"
      style={{
        position: "sticky",
        top: 0,
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "0.75rem",
        padding: "0.5rem 1rem",
        background: "#b91c1c",
        color: "#fff",
        fontSize: "0.875rem",
        fontWeight: 600,
        boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
      }}
    >
      <span>
        Viewing as <strong>{target?.name}</strong> ({target?.email})
        {writeAllowed ? "" : " — read-only"}
      </span>
      <form action={stopPath || "/stop_impersonating"} method="post" style={{ margin: 0 }}>
        <input type="hidden" name="_method" value="delete" />
        <input type="hidden" name="authenticity_token" value={csrf} />
        <button
          type="submit"
          style={{
            background: "#fff",
            color: "#b91c1c",
            border: "none",
            borderRadius: "4px",
            padding: "0.25rem 0.75rem",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Stop impersonating
        </button>
      </form>
    </div>
  );
}
